import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
    selector: 'countdown',
    templateUrl: './countdown.component.html',
    styleUrls: ['./countdown.component.scss']
})
export class CountdownComponent implements OnInit
{
    @ViewChild('countBlock', { static: true }) public countBlock: ElementRef;

    @Output() public timerDone = new EventEmitter();

    @Input() public countdownDate: Date;

    @Input() public showSeconds: boolean;

    @Input() public showAllCountdownBlocks: boolean;
    
    @Input() public useAlternate: boolean;

    @Input() public makeFlex: boolean;

    @Input() public yellowTiles: boolean;

    public days = '--';
    public hours = '--';
    public minutes = '--';
    public seconds = '--';

    public hLineWidth: number;
    public mLineWidth: number;
    public sLineWidth: number;

    private maxLineWidth: number;
    private timer: any;

    public ngOnInit(): void
    {
        this.calcMaxLineWidth();
        this.updateCounter();
    }

    private update(date: Date): void
    {
        if(date == null)
        {
            return;
        }

        const currentDate = new Date();

        if (date.getTime() - currentDate.getTime() <= 0)
        {
            this.timerDone.emit();
        } else
        {
            this.setDisplayValues(date, currentDate);
        }
    }

    private getCountdownValues(date: Date, currentDate: Date): { days: number, hours: number, minutes: number, seconds: number }
    {
        let values = this.translateTimespan(date, currentDate);
        
        const testDate = new Date(currentDate);
        testDate.setDate(testDate.getDate() + values.days);
        testDate.setHours(testDate.getHours() + values.hours);
        testDate.setMinutes(testDate.getMinutes() + values.minutes);
        testDate.setSeconds(testDate.getSeconds() + values.seconds);
        
        var calculatedDiff = testDate.getTime() - date.getTime();

        // Daylight saving time can result in a calculated difference of +- 1 hour. 
        // Check with half an hour difference.
        if(Math.abs(calculatedDiff) > 1800000)
        {
            values = this.translateTimespan(new Date(date.getTime() - calculatedDiff), currentDate);
        }
        
        return values;
    }

    private translateTimespan(date, currentDate): { days: number, hours: number, minutes: number, seconds: number }
    {
        const difference = date.getTime() - currentDate.getTime(); // (unix epoch time)

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        return {
            days,
            hours,
            minutes,
            seconds
        }
    }

    private setDisplayValues(date: Date, currentDate: Date)
    {
        const values = this.getCountdownValues(date, currentDate);
        const timez = [
            ('0' + values.days).slice(-2),
            ('0' + values.hours).slice(-2),
            ('0' + values.minutes).slice(-2),
            ('0' + values.seconds).slice(-2)
        ];

        if (this.minutes === '--')
        {
            setTimeout(() =>
            {
                this.days = timez[0].slice(0, 1);

                setTimeout(() =>
                {
                    this.days = timez[0].slice(0);
                    
                    setTimeout(() =>
                    {
                        this.hours = timez[1].slice(0, 1);

                        setTimeout(() =>
                        {
                            this.hours = timez[1].slice(0);
                            
                            setTimeout(() =>
                            {
                                this.minutes = timez[2].slice(0, 1);

                                setTimeout(() =>
                                {
                                    this.minutes = timez[2].slice(0);
                                    this.calcLineWidth(values.hours, values.minutes, values.seconds);

                                    setTimeout(() =>
                                    {
                                        this.seconds = timez[3].slice(0, 1);

                                        setTimeout(() =>
                                        {
                                            this.seconds = timez[3].slice(0);
                                            this.calcLineWidth(values.hours, values.minutes, values.seconds);
                                        }, 67);
                                    }, 67);
                                }, 67);
                            }, 67);
                        }, 67);
                    }, 67);
                }, 67);
            }, 10);

            return;
        }

        this.days = ('0' + values.days).slice(-2);
        this.hours = ('0' + values.hours).slice(-2);
        this.minutes = ('0' + values.minutes).slice(-2);
        this.seconds = ('0' + values.seconds).slice(-2);
        this.calcLineWidth(values.hours, values.minutes, values.seconds);
    }
    
    private updateCounter(): void
    {
        this.timer = setInterval(() =>
        {
            this.update(this.countdownDate);
        }, 1000);
    }

    private calcMaxLineWidth(): void
    {
        this.maxLineWidth = this.countBlock.nativeElement.offsetWidth;
    }

    private calcLineWidth(h: number, m: number, s: number): void
    {
        this.sLineWidth = (this.maxLineWidth / 60) * s;
        this.mLineWidth = (this.maxLineWidth / 60) * m;
        this.hLineWidth = (this.maxLineWidth / 24) * h;
    }

    @HostListener('window:resize', ['$event'])
    public onResize(): void
    {
        this.maxLineWidth = this.countBlock.nativeElement.offsetWidth;
    }

    public ngOnChanges(changes: SimpleChanges): void
    {
        if (changes.countdownDate)
        {
            this.countdownDate = changes.countdownDate.currentValue;
        }
    }

    public ngOnDestroy(): void
    {
        if (this.timer)
        {
            clearInterval(this.timer);
        }
    }
}
